//#region Libraries
import { useState, useEffect, useRef } from "react";
//#endregion
//#region Styles
import { 
    Container,
    Header, 
    Content,
    Step, 
    Footer, 
    Annotation } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import CustomFileInput from "components/CustomFileInput/CustomFileInput";
//#endregion

const UploadFileWithSteps = ({
    title,
    description, 
    file, 
    onChange, 
    error, 
    errorText = "Es necesario que subas un archivo",
    formatFile = "#",
    annotation
}) => {
    const [formatFileName, setFormatFileName] = useState("");
    //#region Refs
    const $anchorDownload = useRef();
    //#endregion
    //#region Effects
    useEffect(() => {
        setFormatFileName(formatFile.split("/").pop());
    }, [formatFile]);
    //#endregion
    //#region Functions
    const downloadFormat = () => {
        $anchorDownload.current.click();
    }
    //#endregion
    return (
        <Container>
            <Header>
                <h3>{title}</h3>
                {description}
            </Header>
            <Content>
                <Step>
                    <h4>Paso 01:</h4>
                    <p>
                        Si no tienes el formato modelo, te invitamos a descargarlo.
                    </p>
                    <CustomButton
                        text="Descargar Formato"
                        onClick={downloadFormat}/>
                    <a ref={$anchorDownload} 
                        href={formatFile}
                        download={formatFileName}
                        hidden></a>
                </Step>
                <Step>
                    <h4>Paso 02:</h4>
                    <p>
                        Completa el formato modelo y guárdalo con un nombre corto con el que puedas identificarlo más adelante.
                    </p>
                </Step>
                <Step>
                    <h4>Paso 03:</h4>
                    <p>
                        Selecciona y sube el archivo previamente guardado.
                    </p>
                </Step>
                {annotation && 
                <Annotation>
                    <h4>Nota:</h4>
                    <p>{annotation}</p>
                </Annotation>}
            </Content>
            <Footer>
                <CustomFileInput
                    quantityFiles={1}
                    maxSizeMB={30}
                    file={file}
                    onChange={onChange}
                    error={error}
                    errorText={errorText}/>
            </Footer>
        </Container>
    );
}

export default UploadFileWithSteps;